<template>

    <b-col sm="12" :lg="size" :offset="offset">

      <!-- Date Modal -->
      <b-modal
        v-if="withDate"
        title="Choose period"
        class="modal-primary"
        v-model="modalDate"
        @ok="fetchData(), modalDate = false">
        <b-form>
          <b-form-group label="From" label-for="date" :label-cols="3">
            <datepicker use-utc
              format="yyyy-MM-dd"
              :bootstrap-styling="true"
              v-model="dateFrom"
              name="dateFrom"
            ></datepicker>
          </b-form-group>
          <b-form-group label="To" label-for="dateTo" :label-cols="3">
            <datepicker use-utc
              format="yyyy-MM-dd"
              :bootstrap-styling="true"
              v-model="dateTo"
              name="dateTo"
            ></datepicker>
          </b-form-group>
        </b-form>
      </b-modal>
      <!-- Date Modal END -->

      <b-card class="backClass" style="min-height:587px">

        <!-- Header -->
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0"> {{ title }}
            <small style="font-weight:600; color:#20a8d8" v-if="withDate"> {{ from ? from : dateFrom }} <b>|</b> {{ to ? to : dateTo }} </small>
          </h5>
          <div class="card-header-actions">
            <b-button
              variant="transparent p-1"
              attr="pdf"
              @click="downloadPDF()" >
              <i class="fa fa-file-pdf-o" style="color: rgb(32, 168, 216);" aria-hidden="true"></i>
            </b-button>
            <b-button
              @click="modalDateEvent"
              v-if="withDate"
              variant="transparent p-1">
              <i class="icon-calendar" style="color: #20a8d8;"></i>
            </b-button>
            <b-button
              @click="toggleFullScreen"
              variant="transparent p-1">
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
          </div>
        </div>
        <!-- Header END -->

        <!-- Financial Switch -->
        <div style="width: 100%; display: flex; justify-content: flex-end;" v-if="withFinancial">
            <h5>Quantity</h5>
            <c-switch
              class="mx-1"
              color="primary"
              v-model="valueQuantity"
              value="true"
              uncheckedValue="false"
              variant="pill" />
            <h5>Financials</h5>
        </div>
        <!-- Financial Switch END -->

        <div class="chart-wrapper">

          <!-- Loading -->
          <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <!-- Loading END -->

          <!-- Chart -->
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'" />
          <!-- Chart END -->

        </div>

        <!-- Footer -->
        <div slot="footer">
          <b-button
            :disabled="!showAll"
            class="btn-outline"
            variant="outline-primary"
            left
            @click="showAll = false, fetchData()"
          >Top 10</b-button>
          <b-button
            :disabled="showAll"
            class="btn-outline float-right"
            variant="outline-primary"
            right
            @click="showAll = true, fetchData()"
          >All Data</b-button>
        </div>
        <!-- Footer END -->

      </b-card>
    </b-col>

</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import { chartFunctionsMixin } from "./addons/chartFunctionsMixin.js";
import { chartOptionsMixin } from "./addons/chartOptionsMixin.js";
import Datepicker from "vuejs-datepicker";
import { Switch as cSwitch } from "@coreui/vue";
exporting(Highcharts);

export default {
  mixins: [ chartFunctionsMixin, chartOptionsMixin ],
  components: {
    highcharts: Chart,
    Highcharts,
    Datepicker,
    cSwitch
  },
  props: ["size", "offset", "title", "withDate", "withFinancial", "chart", "chartType", "isCompanyOverall", "isCompanyProfile", "company", "city", "cityName", "model", "modelName"],
  methods: {
    fetchData() {
      this.loadingData = true;

      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }
      let params = {};
      let link = null;
      if(this.isCompanyOverall) {
        link = "api/viavi/company/chart_all.php"
      } else if(this.isCompanyProfile) {
        link = "api/viavi/company/chart_profile.php"
      } else if (this.city) {
        link = "api/viavi/charts/chart_city.php"
      } else if (this.model) {
        link = "api/viavi/charts/chart_product.php"
      } else {
        link = "api/viavi/charts/chart_data.php"
      }

      params = {
        type: finType,
        date_from: this.dateFrom,
        date_to: this.dateTo,
        chartType: this.chartType,
        company: this.company ? this.company : "",
        client: this.city,
        model: this.model
      };

      this.$http.get(link, { params }).then(
          res => {
            let tmp = res.data.upData;
            tmp.sort((a, b) => parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1 );

            let smp = res.data.dnData;
            smp ? smp.forEach((value, index) => { value.data.sort((a, b) => parseInt(a[1]) > parseInt(b[1]) ? -1 : 1 );}) : ""

            if (!this.showAll) {
                this.chartOptions.series[0].data = tmp.slice(0, 10);
            } else {
                this.chartOptions.series[0].data = tmp;
            }
            if (!this.isCompanyProfile) {
              this.chartOptions.drilldown.series = smp;
            }
            if(this.isCompanyOverall) {
              this.chartOptions.drilldown.series = null;
            }
            if(this.isCompanyProfile){
              this.chartOptions.drilldown.series = null;
            }
            if (this.model) {
              this.chartOptions.drilldown.series = null;
            }

            if (finType == "Fin") {
              this.chartOptions.title.text = "Total : $" + res.data.totals.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            } else {
              this.chartOptions.title.text = "Total units: " +  res.data.totals;
            }

            this.loadingData = false;
            setTimeout(() => {
              this.changeHeight();
            });
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
